module.exports = __webpack_public_path__ + "static/media/cafe24-order.5c88ac68.png";